import type { TUserActionNotification } from "~/reducers/dashboard";

export function addUserActionNotification(json: TUserActionNotification) {
  return { type: "ADD_USER_ACTION_NOTIFICATION", json } as const;
}

export function addUserActionNotificationError(
  json: Pick<TUserActionNotification, "message"> &
    Partial<Omit<TUserActionNotification, "message">>,
) {
  return addUserActionNotification({ level: "error", position: "tl", autoDismiss: 4, ...json });
}

export function eraseUserActionNotification() {
  return { type: "ERASE_USER_ACTION_NOTIFICATION" } as const;
}
